// 列表页通用代码
import dayjs from "dayjs";
export default {
    data() {
        return {
            loading: false,
            // 总条数
            total: 0,
            // 列表表格数据
            tableData: [],
            // 查询参数
            query: {
                page: 1,
                size: 10,
            },
        };
    },
    created() {
        this.search();
    },
    methods: {
        handleSizeChange(size) {
            this.query.size = size;
            this.handleSearch();
        },
        handleCurrentChange(current) {
            this.query.page = current;
            this.search();
        },
        handleSearch() {
            this.query.page = 1;
            this.search();
        },
        resetQuery() {
            this.handleSearch();
        },
        formatDate(date) {
            return dayjs(date).format("YYYY-MM-DD HH:mm");
        },
    },
};
